"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var DatePickerWithinContext_1 = require("./DatePickerWithinContext");
/**
 * The DatePicker component is an input field that is intended to make it
 * easier for the user to enter a date.
 * A calendar is provided for this purpose, which the user can use to select a
 * date from a range of available data.
 *
 * The date picker field allows you to enter the date using the keyboard or a
 * data picker that opens when the user clicks on the field. The format
 * `TT.MM.YYYYY` is specified as a reference text in the field.
 *
 * <div>
 *   <p class="box box--ux">
 *     This component is useful for date entries for which the user does not yet
 *     have the exact date in his or her head; for example, the start and end date
 *     of flight trips.
 *     For entries where the user knows the exact target date in advance, e. g.
 *     date of birth or wedding day, the <a
 *     href="#!/DateInput">DateInput</a> component is usually the better option.
 *   </p>
 * </div>
 */
exports.DatePicker = withContext_1.withErgoElementsContext('DatePicker', DatePickerWithinContext_1.DatePickerWithinContext);
exports.default = exports.DatePicker;
__export(require("./DatePickerWithinContext"));
//# sourceMappingURL=DatePicker.js.map
